
$(document).ready( function(){
    // if there is at least one accordion on this page
	if ($('.accordion').length > 0){

        // scope of current accordion
        $(document).find('.accordion').each(function(e){

            // determine how many accordion sections there are
            numberOfAccordionSections = $(this).find('.accordion-toggle').length;

            // clicking on accordion-toggle
            $(this).find('.accordion-toggle').on('click', function(e){

                //Expand or collapse this panel and change text to Expand/Collapse
                if($(this).hasClass('open')) {
                    $(this).children('.action').html('<span class="text"></span><span class="icon"><i class="fa fa-angle-down"></i></span>');
                    $(this).removeClass('open');
                    $(this).next().slideUp('fast');
                } else {
                    $(this).children('.action').html('<span class="text"></span><span class="icon"><i class="fa fa-angle-up"></i></span>');
                    $(this).addClass('open');
                    $(this).next().slideDown('fast');
                }

                // set up counter to count how many of the according sections are open
                var count = 0;
                // counting how many of the according sections are open
                $(this).siblings('.accordion-toggle').addBack().each(function () {
                    if ($(this).hasClass('open')) {
                        count ++;
                    }
                });

                var expandAll = $(this).siblings('.mass-expand');

                // if all sections are open change to collapse all
                if (count  == numberOfAccordionSections) {

                    expandAll.children('.action-expand').html('<span class="text-expand"></span><span class="icon"><i class="fa fa-angle-up"></i></span>');

                    expandAll.siblings('.accordion-toggle').each(function () {
                        $(this).removeClass('open');
                        $(this).addClass('open');
                        $(this).next().slideDown('fast');
                    });

                    expandAll.addClass('open-all');

                } else if (count  == 0) {
                    expandAll.children('.action-expand').html('<span class="text-expand">Expand All</span><span class="icon"><i class="fa fa-angle-down"></i></span>');

                    expandAll.siblings('.accordion-toggle').each(function () {
                        $(this).addClass('open');
                        $(this).removeClass('open');
                        $(this).next().slideUp('fast');
                    });

                    expandAll.removeClass('open-all');
                }
            });

            // click on Expand-All
            $(this).find('.mass-expand').on('click', function(e) {

                if ($(this).hasClass('open-all')) {

                    $(this).children('.action-expand').html('<span class="text-expand">Expand All</span><span class="icon"><i class="fa fa-angle-down"></i></span>');

                    $(this).siblings('.accordion-toggle').each(function () {

                        $(this).children('.action').html('<span class="text">Expand</span><span class="icon"><i class="fa fa-angle-down"></i></span>');
                        $(this).removeClass('open');
                        $(this).next().slideUp('fast');
                    });

                    $(this).removeClass('open-all');

                } else {

                    $(this).children('.action-expand').html('<span class="text-expand">Collapse All</span><span class="icon"><i class="fa fa-angle-up"></i></span>');

                    $(this).siblings('.accordion-toggle').each(function () {
                        $(this).children('.action').html('<span class="text"></span><span class="icon"><i class="fa fa-angle-up"></i></span>');
                        $(this).addClass('open');
                        $(this).next().slideDown('fast');
                    });

                    $(this).addClass('open-all');
                }
            });
        });
    }
});